<div class="flex justify-between m-3">
  <div class="text-lg font-bold">Bonus Leaderboards</div>
  <a
    [routerLink]="['/', 'leaderboard_management', 'driver_pools']"
    [queryParams]="{ takeover: true }"
    *lohiFeatureFlag="'editLeaderboardPools'"
    matTooltip="Move Drivers Into Pools"
  >
    <mat-icon>group</mat-icon>
  </a>
</div>
<div class="px-0 lg:px-3" *ngIf="(loadingForPool$ | async) || {} as loadingForPool">
  <div
    class="card-with-shadow bg-white p-3 mb-2"
    *ngFor="let pool of leaderboardPools$ | async; trackBy: 'id' | trackByKey"
  >
    <div class="font-bold flex items-center">
      {{ pool.name }} <mat-spinner class="ml-2" diameter="20" *ngIf="loadingForPool[pool.id]"></mat-spinner>
    </div>
    <ng-container *ngIf="pool.leaderboard as leaderboard; else noLeaderboardsYet">
      <div class="text-gray-700" *ngIf="pool.calculation_type === 'single_shift_earnings'; else multiShiftDescription">
        {{ leaderboard.prize ? 'Prize' : (leaderboard.bonusCents | currencyInPennies) }} Awarded to
        {{ leaderboard.winnerCount }} Best Shift<ng-container *ngIf="leaderboard.winnerCount !== 1">s</ng-container>
      </div>
      <ng-template #multiShiftDescription>
        <div class="text-gray-700">
          {{ leaderboard.prize ? 'Prize' : (leaderboard.bonusCents | currencyInPennies) }} Awarded to
          {{ leaderboard.winnerCount }} Best Driver<ng-container *ngIf="leaderboard.winnerCount !== 1">s</ng-container>
          over Multiple Shifts
        </div>
      </ng-template>
      <div class="flex py-1">
        <button
          class="text-sm text-blue-500 font-semibold uppercase"
          [class.cursor-not-allowed]="!leaderboard.previousId || loadingForPool[pool.id]"
          [class.opacity-50]="!leaderboard.previousId || loadingForPool[pool.id]"
          (click)="loadLeaderboard(pool.id, leaderboard.previousId)"
        >
          prev
        </button>
        <div class="flex-1 text-center">Started at {{ leaderboard.createdAt | standardDate }}</div>
        <button
          class="text-sm text-blue-500 font-semibold uppercase"
          [class.cursor-not-allowed]="!leaderboard.nextId || loadingForPool[pool.id]"
          [class.opacity-50]="!leaderboard.nextId || loadingForPool[pool.id]"
          (click)="loadLeaderboard(pool.id, leaderboard.nextId)"
        >
          next
        </button>
      </div>
      <div class="text-center text-sm" *ngIf="leaderboard.completedAt; else notOver">
        <span class="text-gray-600 font-semibold"
          >Last Driver Finished At {{ leaderboard.completedAt | standardDate }}</span
        >
      </div>
      <ng-template #notOver>
        <div class="text-center text-sm">
          <span class="text-blue-500 uppercase font-semibold">In Progress</span>
        </div>
      </ng-template>
      <div>
        <ng-container *ngIf="leaderboard.ranks?.length > 0; else nobodyInPool">
          <a
            @fadeIn
            class="flex p-1 text-gray-800 even:bg-gray-300"
            [routerLink]="['/', 'drivers', rank.userId]"
            *ngFor="
              let rank of leaderboard.ranks | conditionalSlice: 0:5:(expandedLeaderboardPools$$ | async)[pool.id];
              trackBy: 'id' | trackByKey
            "
          >
            <div class="w-4">#{{ rank.rank }}</div>
            <div class="flex-1">
              <ng-container *ngIf="rank.qualifiesForPrize; else notQualified"
                >👑 <span class="font-bold" style="color: #c6a97d">{{ rank.name }}</span></ng-container
              >
              <ng-template #notQualified>
                {{ rank.name }}
              </ng-template>
            </div>
            <div class="text-right">{{ rank.carrierEarningsCents | currencyInPennies }}</div>
          </a>
          <div class="flex justify-center" *ngIf="leaderboard.ranks?.length > 5">
            <button
              class="text-blue-500 uppercase font-semibold text-sm"
              *ngIf="(expandedLeaderboardPools$$ | async)[pool.id]; else viewFewer"
              (click)="collapseLeaderboardPool(pool.id)"
            >
              Collapse
            </button>
            <ng-template #viewFewer>
              <button class="text-blue-500 uppercase font-semibold text-sm" (click)="expandLeaderboardPool(pool.id)">
                View All (+{{ leaderboard.ranks?.length - 5 }} More)
              </button>
            </ng-template>
          </div>
        </ng-container>
        <ng-template #nobodyInPool>
          <div class="text-gray-600" *ngIf="leaderboard.isEnded; else nobodyInPoolNotEnded">
            No Drivers participated in this leaderboard
          </div>
          <ng-template #nobodyInPoolNotEnded>
            <div class="text-gray-600">
              No drivers are currently in this leaderboard. They will be added as qualifying drivers start new shifts.
            </div>
          </ng-template>
        </ng-template>
      </div>
    </ng-container>
    <ng-template #noLeaderboardsYet>
      <div class="text-gray-700" *ngIf="pool.calculation_type === 'single_shift_earnings'; else multiShiftDescription">
        {{ pool.prize ? 'Prize' : (pool.bonusCents | currencyInPennies) }} Awarded to {{ pool.winnerCount }} Best
        Shift<ng-container *ngIf="pool.winnerCount !== 1">s</ng-container>
      </div>
      <ng-template #multiShiftDescription>
        <div class="text-gray-700">
          {{ pool.prize ? 'Prize' : (pool.bonusCents | currencyInPennies) }} Awarded to {{ pool.winnerCount }} Best
          Driver<ng-container *ngIf="pool.winnerCount !== 1">s</ng-container> over Multiple Shifts
        </div>
      </ng-template>
      <div class="text-gray-700">No leaderboards have been started yet</div>
    </ng-template>
  </div>
</div>
